import React from 'react'

function Pencil ({ className, fill }) {
  return (
    <svg fill={fill} className={className} viewBox='0 0 12.25 12.25'>
      <path d='M11.73,2.23,10,.51a1.75,1.75,0,0,0-2.47,0L0,8.05v4.2H4.2l7.54-7.54h0A1.76,1.76,0,0,0,11.73,2.23ZM.81,9.19l2.25,2.25H.81Zm.17-1L7.1,2.09l3.06,3.06L4,11.27Zm6.69-6.7.44-.43a1,1,0,0,1,1.33,0L11.17,2.8a1,1,0,0,1,.27.67.93.93,0,0,1-.28.67l-.43.44Z' />
    </svg>
  )
}

Pencil.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Pencil
